import { render, staticRenderFns } from "./TagsEditor.yaml?vue&type=template&id=085a0405&component"
import script from "./TagsEditor.yaml?vue&type=script&lang=ts&component"
export * from "./TagsEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports